import * as React from 'react'
import {UUID} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {globals} from '../extensions/globals-base'
import {UIRegistry} from './model/ui-registry'

interface Props {
  id: DataObjectId
  children?: React.ReactNode
}

export class UIComponent extends React.Component<Props> {
  private el: HTMLElement
  private handler: UUID
  private reg: UIRegistry

  private up(): void {
    if (!this.props.id) {
      return
    }
    const ui = this.reg.get(this.props.id)
    if (!ui) {
      this.el.removeAttribute('style')
      this.el.classList.remove('ui-hide-defaults')
      this.el.onclick = (): void => {
        //
      }
      const cnt: HTMLElement = this.el.querySelector('.ui-cnt')
      if (cnt) {
        cnt.innerHTML = ''
      }
    } else {
      const found = this.el.getElementsByClassName('ui-cnt')
      let cnt = (found ? found[0] : undefined) as HTMLElement
      if (!cnt) {
        cnt = document.createElement('div')
        this.el.appendChild(cnt)
      }
      ui.render(cnt, this.el)
    }
  }

  public override componentDidMount(): void {
    this.reg = UIRegistry.get(globals.getCompanyId())
    this.handler = this.reg.addListener(this.props.id, () => this.up())
    this.up()
  }

  public override componentWillUnmount(): void {
    this.reg.removeListener(this.handler)
    const ui = this.reg.get(this.props.id)
    if (ui) {
      ui.onUnmount?.()
    }
  }

  public override render(): React.ReactNode {
    return (
      <div className="ui-elem" ref={(el: HTMLElement) => (this.el = el)}>
        {this.props.children}
      </div>
    )
  }
}
